// this is a field that allows the user to set a "Do Not Disturb" status for a
// specific time period. It has a toggle to enable/disable the DND status, and a
// datetime picker to select the end time of the DND period. If DND is disabled,
// the end time should be sent as null. If DND is enabled, the end time should
// be sent as a valid datetime string.

import React, { useState } from 'react';
import DateTimePicker from './DateTimePicker';
import { Form } from '../ui-kit';
import moment from 'moment';

const style = { scale: '1.7', marginLeft: '0.8rem' };
const OFF = '1970-01-01';

const calculateEnabled = value => !value || !moment().isAfter(value);

const DoNotDisturbField = ({ value, name, inputName }) => {
  // if value is in the future or null, then it is enabled, otherwise it is
  // disabled
  const [localValue, setLocalValue] = useState(value === null || moment().isBefore(value) ? value : OFF);

  const enabled = calculateEnabled(localValue);

  const handleChange = newValue => {
    if (newValue === null) {
      setLocalValue(null);
      return;
    }

    if (newValue === OFF) {
      setLocalValue(OFF);
      return;
    }

    // Explicitly convert to moment
    newValue = moment(newValue);
    // If the date is not valid, dont update
    if (!newValue.isValid()) return;

    // if new value is in the past and not equal to OFF, then set it to one hour
    // from now
    if (newValue.isBefore(moment())) {
      newValue = moment().add(1, 'hour').startOf('minute');
    }

    setLocalValue(newValue.format());
  };

  console.log('DoNotDisturbField', { value, localValue, enabled });

  // Note that 'null' is encoded as an empty string, as per Rails controller
  // convention
  return (
    <div className="dnd-field hstack gap-2 align-items-center">
      <Form.Check // prettier-ignore
        type="switch"
        checked={enabled}
        onChange={e => handleChange(e.target.checked ? null : OFF)}
        style={style}
      />

      {enabled && (
        <DateTimePicker
          value={localValue}
          onChange={handleChange}
          name={name}
          compact={true}
          allowOpenEnded={true}
          minDateTime={moment().format()}
        />
      )}
      <input type="hidden" name={inputName} value={localValue || ''} readOnly />
    </div>
  );
};

export default DoNotDisturbField;
